import React from "react";
import MemoizedFretboard from "../../Exercises/Fretboard";
import TriadHelpService       from "../../../services/TriadHelpService";

class TheoryGuitarTriad extends React.Component {
    constructor() {
        super();


        const chordType = window.location.href.split('/')[6]
        let helpService  = new TriadHelpService();

        if(chordType ==='major_minor_diminished') {
            this._triadInfo    = helpService.majMinDimTriads()
        }
        else if(chordType==='minor') {
            this._triadInfo    = helpService.minortriads()
        }
        else if(chordType==='major') {
            this._triadInfo    = helpService.majortriads()
        }
        else if(chordType==='sus2') {
            this._triadInfo    = helpService.sus2triads()
        }
        else if(chordType==='sus4') {
            this._triadInfo    = helpService.sus4triads()
        }
        else if(chordType==='diminished') {
            this._triadInfo    = helpService.diminishedtriads()
        }
        this._stringCombos = this._triadInfo.stringCombos;
    }

    showPositionNotesTable(positions) {
        return (
        <div className="row">
            {positions.map((currentPosition, index) => (
                <div className="col-sm">
                    <b>{currentPosition.positionTitle}</b>
                    <MemoizedFretboard notes={currentPosition.notes}  callback={null} that={null}
                                       helpNotes={currentPosition.notesAtPosition}
                                       hidedots={false}  />
                </div>
            ))}
        </div>)
    }
    showPositions(title, stringCombos) {
        return (
            <div>
                {stringCombos.map((stringCombo, index) => (
                    <div>
                        <h2>{stringCombo.stringTitle} String Positions</h2>
                        {title} triads have the following positions on the {stringCombo.stringTitle} strings:<br/><br/>
                        {this.showPositionNotesTable(stringCombo.positions)}
                    </div>
                    ))}
            </div>
        )
    }
    render() {
        let marj = this._positions

        return (
            <div>


                <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4291774784254135"
                        crossOrigin="anonymous"></script>

                <ins className="adsbygoogle"
                     style={{'display':'block'}}
                     data-ad-client="ca-pub-4291774784254135"
                     data-ad-slot="5721109276"
                     data-ad-format="auto"
                     data-full-width-responsive="true"></ins>
                <script>
                    (adsbygoogle = window.adsbygoogle || []).push({});
                </script>

                <h1>{this._triadInfo.mainTitle} Triads</h1>
                Triads are three-note chords. The chord notes all belong to the same scale.
                These same chords can be played in multiple positions all across the entire guitar neck to create
                different tones and also to span multiple octaves.<br/><br/>

                {this._triadInfo.detail} <br/><br/>

                {this._stringCombos!=null?this.showPositions(this._triadInfo.mainTitle, this._stringCombos):""}
            </div>
        )
    }
}
export default TheoryGuitarTriad;
